import React from "react";
import { FiCheck } from "react-icons/fi";
import { twMerge } from "tailwind-merge";

const PricingCard = ({
  name,
  price,
  description,
  features,
  recommended = false,
}) => {
  return (
    <article
      className={twMerge(
        "htb-card htb-pricing-card relative flex h-full flex-col rounded-2xl border bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift sm:p-8",
        recommended
          ? "htb-pricing-card-recommended border-brand-500 bg-gradient-to-b from-brand-50 to-white ring-4 ring-brand-100"
          : "border-slate-200"
      )}
    >
      {recommended && (
        <div className="htb-plan-badge absolute right-6 top-6 rounded-full bg-brand-600 px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-white">
          Recommended
        </div>
      )}

      <div className="pr-28">
        <p className="htb-plan-name font-display text-[28px] font-medium leading-tight text-slate-900">
          {name}
        </p>
        <p className="htb-plan-description mt-4 text-sm leading-6 text-slate-600">{description}</p>
      </div>

      <div className="htb-plan-price-wrap mt-8">
        <p className="htb-plan-price font-display text-4xl font-bold tracking-tight text-slate-950">
          {price}
        </p>
        <p className="htb-plan-note mt-2 text-sm text-slate-500">Service commission per engagement</p>
      </div>

      <ul className="htb-feature-list mt-8 flex flex-1 flex-col gap-4">
        {features.map((feature) => (
          <li key={feature} className="flex gap-3 text-sm leading-6 text-slate-700">
            <span className="htb-check mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
              <FiCheck className="h-3.5 w-3.5" aria-hidden="true" />
            </span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <a
        href="/contact"
        className={twMerge(
          "htb-button htb-plan-cta mt-8 inline-flex h-12 items-center justify-center rounded-xl px-5 text-sm font-semibold no-underline transition-all duration-200 active:scale-[0.98]",
          recommended
            ? "htb-button-primary bg-brand-600 text-white shadow-brand hover:-translate-y-0.5 hover:bg-brand-700 hover:shadow-lift"
            : "htb-button-secondary border border-slate-300 text-slate-900 hover:-translate-y-0.5 hover:border-brand-400 hover:text-brand-700 hover:shadow-soft"
        )}
      >
        Request a Demo
      </a>
    </article>
  );
};

export default PricingCard;
